import { AppState } from 'src/app/core/core.state'
import { ResourceEffects } from 'src/app/shared/resource-effects'

import { Injectable } from '@angular/core'
import { Actions } from '@ngrx/effects'
import { Store } from '@ngrx/store'

import { CompetitionStaffFunction } from './competition-staff-function'
import { competitionStaffFunctionActions } from './competition-staff-function.actions'
import * as fromCompetitionStaffFunction from './competition-staff-function.reducer'
import { CompetitionStaffFunctionService } from './competition-staff-function.service'

@Injectable()
export class CompetitionStaffFunctionEffects extends ResourceEffects<CompetitionStaffFunction> {
  constructor(
    public actions$: Actions,
    public store: Store<AppState>,
    public competitionStaffFunctionService: CompetitionStaffFunctionService
  ) {
    super(
      fromCompetitionStaffFunction.FEATURE_NAME,
      competitionStaffFunctionService,
      competitionStaffFunctionActions,
      actions$
    )
  }
}
